/**
 * The id of the page's main landmark: the skip link's target and the element
 * "Back to top" refocuses. Set on <main> (tabIndex -1) in the shell and nowhere
 * else in the app.
 */
export const MAIN_CONTENT_ID = "main-content";
